import { render, staticRenderFns } from "./CadastrarSubCategoriaFinanceira.vue?vue&type=template&id=17be5791&scoped=true"
import script from "./CadastrarSubCategoriaFinanceira.vue?vue&type=script&lang=js"
export * from "./CadastrarSubCategoriaFinanceira.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17be5791",
  null
  
)

export default component.exports